import Container from '../general/container/Container';
import LinkUrl from '../general/link/LinkUrl';
import ArrowRight from '../svg/ArrowRight';
import style from './breadcrumbs.module.scss';

export interface BreadcrumbItem {
    title: string;
    url?: string;
}

interface Props {
    items: BreadcrumbItem[];
    classes?: string[];
}

const Breadcrumbs = ({items, classes = []}: Props) => {
  return (
    <nav className={`${style.breadcrumbs} ${classes.join(' ')}`}>
        <Container>
            {
                items.map((item, index) => 
                    <div className={style.breadcrumb} key={index}>
                        <LinkUrl 
                            text={item.title}
                            url={item.url}
                            noLink={!item.url}
                            classes={[style.link, index == items.length - 1 ? style.current : '']}
                        />
                        {
                            index !== items.length - 1
                            ?
                            <span className={style.arrow}>
                                <ArrowRight hexColor='black' width={7} height={7} />
                            </span>
                            : <></>
                        }
                    </div>
                )
            }
        </Container>
    </nav>
  )
};

export default Breadcrumbs;
